import React, { useEffect, useState } from 'react';
// import * as Sentry from '@sentry/react';
import { getCurrentUser, setCurrentUser } from './stores/appStore';
import { BrowserRouter } from 'react-router-dom';

import AuthService from 'services/AuthService';
import { ToastContainer } from 'react-toastify';

import AppRoutes from './Routes';
import AppLoadingIndicator from './AppLoadingIndicator';
import { setLocale } from 'commons/locale/localeSettings';
import StorageService from 'services/StorageService';
import {
  DEFAULT_AGENDA_INTERVAL,
  DEFAULT_AGENDA_SIZE,
  setAgendaLayoutConfig,
} from 'commons/helpers/agendaLayoutConfig';
import { setAppType } from 'commons/helpers/appTypeSettings';

function App() {
  const [isStartingUp, setIsStartingUp] = useState(true);

  useEffect(() => {
    StorageService.clearExpenseListFilters();
    const currentUser = getCurrentUser();

    const loadedAgendaLayoutConfig = StorageService.getAgendaLayoutConfig();
    if (!loadedAgendaLayoutConfig) {
      const agendaLayoutConfig = {
        durationInterval: DEFAULT_AGENDA_INTERVAL,
        lineSize: DEFAULT_AGENDA_SIZE,
      };

      StorageService.setAgendaLayoutConfig(agendaLayoutConfig);
      setAgendaLayoutConfig(agendaLayoutConfig);
    } else {
      setAgendaLayoutConfig(loadedAgendaLayoutConfig);
    }

    if (AuthService.isUserLoggedIn(currentUser)) {
      AuthService.getLoggedInUser()
        .then((userPrincipal) => {
          if (process.env.NODE_ENV === 'production') {
            // Sentry.setUser({ email: userPrincipal.email });
          }
          setCurrentUser({ ...currentUser, principal: { ...userPrincipal } });
          setLocale(userPrincipal.locale);
          setAppType(userPrincipal.occupationAreaId);
        })
        .finally(() => {
          setIsStartingUp(false);
        });
    } else {
      setIsStartingUp(false);
    }
  }, []);

  if (isStartingUp) {
    return <AppLoadingIndicator />;
  }

  return (
    <>
      <ToastContainer limit={5} hideProgressBar={true} />
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </>
  );
}

export default App;
